const USER_LOGOUT = "USER_LOGOUT";

export const logoutUser = () => {
    return {
        type: USER_LOGOUT,
    };
};
